import { object, string } from "yup";

const getEducationInputs = (t) => [
  {
    name: "schoolName",
    label: t("education.fields.name.label"),
    type: "text",
    placeholder: t("education.fields.name.placeholder"),
  },
  {
    name: "schoolCity",
    label: t("education.fields.city.label"),
    type: "text",
    placeholder: t("education.fields.city.placeholder"),
  },
  {
    name: "schoolState",
    label: t("education.fields.state.label"),
    type: "text",
    placeholder: t("education.fields.state.placeholder"),
  },
  {
    name: "schoolZip",
    label: t("education.fields.zip.label"),
    type: "text",
    placeholder: t("education.fields.zip.placeholder"),
  },
  {
    name: "startDate",
    label: t("education.fields.startDate.label"),
    type: "date",
    placeholder: t("education.fields.startDate.placeholder"),
  },
  {
    name: "endDate",
    label: t("education.fields.endDate.label"),
    type: "date",
    placeholder: t("education.fields.endDate.placeholder"),
  },
];

const getValidationSchema = (t) =>
  object().shape({
    schoolName: string()
      .required(t("education.validation.nameRequired"))
      .min(2, t("education.validation.nameMin"))
      .max(100, t("education.validation.nameMax")),
    schoolCity: string()
      .required(t("education.validation.cityRequired"))
      .min(2, t("education.validation.cityMin"))
      .max(100, t("education.validation.cityMax")),
    schoolState: string()
      .required(t("education.validation.stateRequired"))
      .max(2, t("education.validation.stateMax"))
      .matches(
        /^([A-Za-zÀ-ÖØ-öø-ÿ\s]*)$/gi,
        t("education.validation.stateLetters")
      ),
    schoolZip: string()
      .min(5, t("education.validation.zipMin"))
      .required(t("education.validation.zipRequired")),
    startDate: string()
      .min(10, t("education.validation.dateFormat"))
      .max(10)
      .required(t("education.validation.startDateRequired")),
    endDate: string()
      .min(10, t("education.validation.dateFormat"))
      .max(10)
      .required(t("education.validation.endDateRequired")),
  });

const getHandleValidations = (t) => (values) => {
  let errors = {};

  // Validate startDate is not in the future
  if (values.startDate && values.startDate !== "") {
    const startDate = new Date(values.startDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (startDate > today) {
      errors.startDate = t("education.validation.startDateFuture");
    }
  }

  // Validate endDate is not in the future
  if (values.endDate && values.endDate !== "") {
    const endDate = new Date(values.endDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (endDate > today) {
      errors.endDate = t("education.validation.endDateFuture");
    }
  }

  // Validate endDate is after startDate
  if (values.startDate && values.endDate) {
    const startDate = new Date(values.startDate);
    const endDate = new Date(values.endDate);
    if (endDate < startDate) {
      errors.endDate = t("education.validation.endDateAfterStart");
    }
  }

  if (values.schoolZip && !/^[0-9]+$/i.test(values.schoolZip)) {
    errors.schoolZip = t("education.validation.zipNumeric");
  }
  return errors;
};

export { getEducationInputs, getValidationSchema, getHandleValidations };
